import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { CookieService } from 'ngx-cookie-service';
import { PagerService } from '../../services/index';
declare var $: any;
declare var External: any;

@Component({
	selector: 'app-view-survey',
	templateUrl: './view-survey.component.html',
	styleUrls: ['./view-survey.component.css']
})
export class ViewSurveyComponent implements OnInit {
	survey: any;
	surveyId: any;
	isActive: boolean;
	prevUrl: any;
	base64Str: any;
	prevRoute: any;
	surveyTypeId: any;
	decodedUrl: any;
	listType: any;
	group_id: null;
	constructor(private validationService: ValidationService, private authService: AuthService, private commonService: CommonService,
		private cookieService: CookieService, private router: Router, private pagerService: PagerService, private activatedRoute: ActivatedRoute) {
	}

	ngOnInit() {

		this.activatedRoute.params.subscribe((params: any) => {

			if (params.survey_id && params.prev_token) {
		
				this.surveyId = params.survey_id;
				this.group_id = params.group_id;
				this.prevUrl = params.prev_token;
				this.decodedUrl = decodeURIComponent(params.prev_token);
				this.surveyTypeId = this.decodedUrl.split('&surveyTypeId=');
				this.listType = this.decodedUrl.split('&type=');
				if (this.surveyTypeId[1] == "5a66e31e85cfcd3f9289197c") {
					this.prevRoute = '/country-survey-list';
				}
				else if (this.surveyTypeId[1] == "5a66e31385cfcd3f9289197b") {
					this.prevRoute = '/world-survey-list';
				}
				else if(this.surveyTypeId[1] == "5cd401a5c5bd18148c2f040f"){
					this.prevRoute = '/city-survey-list';
				}
				else if (this.surveyTypeId[1] == "123456") {
					this.prevRoute = '/group-survey-list';
				}
				else if (this.surveyTypeId[1] == "") {
					this.prevRoute = '/survey-list';
				}
				else if (this.listType[1] == 1) {
					this.prevRoute = '/survey-report';
				}
				else if (this.listType[1] == 2) {
					this.prevRoute = '/survey-answer-report';
				}
				else {
					this.prevRoute = '/transaction-report';
				}
				if (!this.group_id) {
					this.authService.getSurveyById(params.survey_id).subscribe(data => {
						if (data.success) {
							this.survey = data.survey;
							this.isActive = data.survey.survey_status;
						}
						$(".navbar-brand").text("Survey Detail");
					});
				} else {
					this.authService.getGroupSurveyById(params.survey_id, this.group_id).subscribe(data => {
			
						if (data.success) {
					
							this.survey = data.survey;
							console.log(this.survey)
							this.isActive = data.survey.survey_status;
						}
						$(".navbar-brand").text("Survey Detail");
					});
				}
			}
		});
	}

	// Update survey status .
	updateSurveyStatus = function () {
		//if (!this.group_id) {
			this.authService.updateSurveyStatus(this.surveyId).subscribe(data => {
				if (data.success) {
					$.growl.notice({ title: 'Success', message: data.message });
					this.isActive = !this.isActive;
				}
				else {
					$.growl.error({ title: 'Error', message: data.error });
				}
			});
		/*}
		else {
			this.authService.updateGroupSurveyStatus(this.surveyId).subscribe(data => {
				if (data.success) {
					$.growl.notice({ title: 'Success', message: data.message });
					this.isActive = !this.isActive;
				}
				else {
					$.growl.error({ title: 'Error', message: data.error });
				}
			});
		}*/
	}

	// Delete Survey
	deleteSurvey = function () {
		//if (!this.group_id) {
			this.authService.deleteSurvey(this.surveyId).subscribe(data => {
				if (data.success) {
					this.isDeleted = true;
					this.authService.cancelProcess();
					$('.btn_back').click();
					$.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					$.growl.error({ title: 'Error', message: data.error });
				}
			});
		/*}
		else {
			this.authService.deleteGroupSurvey(this.surveyId).subscribe(data => {
				if (data.success) {
					this.isDeleted = true;
					this.authService.cancelProcess();
					$('.btn_back').click();
					$.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					$.growl.error({ title: 'Error', message: data.error });
				}
			});
		}*/
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/view-survey/view-survey.component.ts